import AppContext from '../../../core/AppContext';
import './HeroStatic.css';
import HeroArt from './HeroArt';
import './HeroArt.css';
export default function HeroStatic() {

    const conference = AppContext.conference;

    const registrationEnabled =
        conference.settings?.registration?.show === true;

    const programmeEnabled =
        conference.settings?.programme?.show === true;

    return `
       <section id="home" class="hero">
		<div class="hero__background"></div>
			<div class="container hero__container">

        <div class="hero__content">

           <!-- Eyebrow -->
    <div class="section__eyebrow">
        Jagiellonian University
    </div>

    <!-- Tytuł z wyróżnionym rokiem -->
<h1 class="hero__title">PIEROGY <span class="hero__title-year">2027</span></h1>
    <!-- Podtytuł -->
    
    <p class="hero__subtitle">
    <span class="highlight">P</span>erspectives
    <span class="highlight">I</span>n
    <span class="highlight">E</span>rgodic Theory,
    <span class="highlight">R</span>and<span class="highlight">O</span>mness
    and
    <span class="highlight">G</span>eometr<span class="highlight">Y</span>
</p>

    <!-- Pastylka z metadanymi -->
   <div class="hero__metadata">
    <span class="hero__metadata-item">
        <!-- Ikona Kalendarza SVG -->
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        19–23 April 2027
    </span>
    
    <span class="hero__metadata-separator">•</span>
    
    <span class="hero__metadata-item">
        <!-- Ikona Pinu (Lokalizacji) SVG -->
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
        </svg>
        Kraków, Poland
    </span>
</div>

    <!-- Przyciski akcji -->
   <div class="hero__actions">
    ${registrationEnabled ? `
        <a href="#register" class="btn btn-primary">
            Register Now
        </a>
    ` : ''}

    ${programmeEnabled ? `
        <a href="#programme" class="btn btn-primary">
            View Programme
        </a>
    ` : ''}


        </div>
        </div>

        <div class="hero__art">

             ${HeroArt()}
        </div>

    </div>

</section>

      
    `;

}
